<template>
  <BModal
    v-if="show"
    active
    has-modal-card
    @close="close"
  >
    <keep-alive>
      <component
        :is="component"
        ref="componentRef"
      />
    </keep-alive>
  </BModal>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'AppModalForm',
  components: {
    NewCustomer: () => import(/* webpackChunkName: "new-customer" */ '@/components/Admin/Customer/New.vue'),
    ReasonCancellation: () => import(/* webpackChunkName: "filters-report" */ '@/components/Invoices/History/ReasonCancellation.vue'),
    CfdisRelated: () => import(/* webpackChunkName: "cfdi-related" */ '@/components/Admin/CFDI/CfdisRelated.vue'),
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      show: state => state.modalForm.show,
      component: state => state.modalForm.component,
      methods: state => state.modalForm.methods,
    }),
  },
  methods: {
    close(event) {
      this.$modalForm({ show: false, methods: this.methods },
        (methods) => {
          const { onClosed } = methods;
          return onClosed ? onClosed(event) : () => {};
        });
    },
  },
};
</script>
<style scoped>
form {
  width: auto;
}
</style>
